import { Component, OnInit, Inject } from '@angular/core';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { OAuthService } from 'angular-oauth2-oidc';
import {Router} from '@angular/router';


@Component({
	selector: 'app-info-dialog',
	templateUrl: './info-dialog.component.html',
	styleUrls: ['./info-dialog.component.scss'],
})
export class InfoDialogComponent {
	showTechnicalError: boolean = false;
	constructor(private oauthService: OAuthService, private router: Router, @Inject(NX_MODAL_DATA) readonly data: any) {
		
	}

	toggleTechnicalError() {
		this.showTechnicalError = !this.showTechnicalError;
	}
}
